import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'

import { Relationship } from '../../models/relationship.model'

@Component({
  selector: 'ld-select-relationship',
  template: require('./select-relationship.component.html'),
  styles: [require('./select-relationship.component.css')]
})
export class SelectRelationshipComponent implements OnInit {
  @Input('active') active: string
  @Output('activeChange') activeChange = new EventEmitter<string>()
  private options = []

  ngOnInit () {
    this.options = new Relationship().generateSelectType()
  }

  onChange (value) {
    this.activeChange.emit(value)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/select-relationship/select-relationship.component.ts